import * as v from "valibot";

import { rpcContract } from "../rpc";

export const worldsQueryRpcContract = rpcContract({
  name: "worldsQuery",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    worlds: v.array(
      v.object({
        id: v.string(),
        name: v.string(),
        mediaUrl: v.nullable(v.string()),
        mediaPositionX: v.nullable(v.number()),
        mediaPositionY: v.nullable(v.number()),
        postCount: v.number(),
        status: v.union([v.literal("live"), v.literal("draft")]),
        createdAt: v.string(),
        updatedAt: v.string(),
      }),
    ),
    counts: v.object({
      live: v.number(),
      draft: v.number(),
    }),
  }),
});

export type WorldsQueryParams = v.InferOutput<(typeof worldsQueryRpcContract)["paramsSchema"]>;
export type WorldsQueryResult = v.InferOutput<(typeof worldsQueryRpcContract)["resultSchema"]>;
export type World = v.InferOutput<(typeof worldsQueryRpcContract)["resultSchema"]>["worlds"][0];
export type WorldStatus = World["status"];
